import { getWindow } from './getWindow';
import { getOffset } from './getOffset';


/**
* 获取 DOM 元素的高度
* @param node DOM 元素
* @param client 是否获取客户端高度
* @returns DOM 元素的高度
*/
export const getHeight = (node: Element | Window, client?: Element): number => {
  const win = getWindow(node);

  if (win) {
    return win.innerHeight;
  }

  //@ts-ignore
  return client ? (node as Element).clientHeight : getOffset(node as Element).height;
}